import {initModal} from '../../resources/js/module/modal';
import acc from "../../resources/js/module/acc_tip";

document.addEventListener('DOMContentLoaded', () => {
    initModal();
    acc(document.querySelector('.tjc-acc'), { allOpen: true });
});
